import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from 'react-router-dom'

const IDLE_TIMEOUT = 1 * 60 * 1000; // 5 minutes


function IdleTimeout() {
    const navigate = useNavigate();

    
  const handleOnIdle = () => {
    navigate("/login")
  };

  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return null; // No UI needed
}

export default IdleTimeout;
